/**
 * `FRM-03` — filtro de autocomplete ignora acento e caixa.
 *
 * Sem isto, "Jose" não acha "José" e "sao joao" não acha "São João": o campo responde "sem
 * resultados" para um registro que existe, e quem está digitando conclui que o cadastro não
 * foi feito. É o tipo de erro que não aparece em teste, porque quem escreve o teste digita
 * o nome com o acento certo.
 *
 * Serve para **comparar**, nunca para exibir: o texto devolvido é a chave de busca, não o
 * rótulo.
 */
export function normalizarTexto(texto: string | null | undefined): string {
  return (texto ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

/** Açúcar para o caso mais comum: "o alvo contém o que foi digitado?", sem acento e sem caixa. */
export function contemNormalizado(alvo: string | null | undefined, termo: string | null | undefined): boolean {
  const t = normalizarTexto(termo);
  return !t || normalizarTexto(alvo).includes(t);
}
